export enum CredentialStoreResourceType {
    AssetCredential,
    RobotCredential,
}

export interface ICredentialStoreResource {
    id: number;
    name: string;
    type: CredentialStoreResourceType;
}

export enum CredentialStoreGenericType {
    Database,
    SecureStore,
}

export interface ICredentialStoreType {
    value: string;
    genericType: CredentialStoreGenericType;
}

export interface ICredentialStoreDetails {
    isReadOnly: boolean;
}

export interface ICredentialStore {
    id: number;
    type: ICredentialStoreType;
    name: string;
    additionalConfiguration?: Record<string, any>;
    details: ICredentialStoreDetails;
}

export enum ConfigurationEntryValueType {
    String = 'String',
    Boolean = 'Boolean',
    Number = 'Number',
    Section = 'Section',
    Choice = 'Choice',
}

export interface ICredentialStoreConfigurationEntry {
    key: string;
    displayName: string;
    isMandatory: boolean;
    defaultValue?: boolean | string | number;
    defaultValueAsString?: string;
    valueType: ConfigurationEntryValueType;
    possibleValues?: string[];
    configurations?: ICredentialStoreConfigurationEntry[];
}
